import type {RequiredPlan} from './copilot-chat-types'

export type RecommendedModelCategory = 'lightweight' | 'versatile' | 'powerful'

const OPENAI_LOGO = '/images/modules/marketplace/models/families/openai-logo.svg'
const ANTHROPIC_LOGO = '/images/modules/marketplace/models/families/anthropic.svg'

// `requiredPlan` is the minimum plan needed to access the model; omit for models available to all plans.
export type RecommendedModelEntry = {
  id: string
  category: RecommendedModelCategory
  displayName: string
  logoURL: string
  vendor: string
  requiredPlan?: RequiredPlan
}

export const RECOMMENDED_MODELS = [
  {
    id: 'gpt-5.4-mini',
    category: 'lightweight',
    displayName: 'GPT-5.4 mini',
    logoURL: OPENAI_LOGO,
    vendor: 'OpenAI',
    requiredPlan: 'edu',
  },
  {
    id: 'claude-haiku-4.5',
    category: 'lightweight',
    displayName: 'Claude Haiku 4.5',
    logoURL: ANTHROPIC_LOGO,
    vendor: 'Anthropic',
    requiredPlan: undefined,
  },
  {
    id: 'claude-sonnet-4.6',
    category: 'versatile',
    displayName: 'Claude Sonnet 4.6',
    logoURL: ANTHROPIC_LOGO,
    vendor: 'Anthropic',
    requiredPlan: 'pro',
  },
  {
    id: 'claude-sonnet-4.5',
    category: 'versatile',
    displayName: 'Claude Sonnet 4.5',
    logoURL: ANTHROPIC_LOGO,
    vendor: 'Anthropic',
    requiredPlan: 'pro',
  },
  {
    id: 'gpt-5.2',
    category: 'versatile',
    displayName: 'GPT-5.2',
    logoURL: OPENAI_LOGO,
    vendor: 'OpenAI',
    requiredPlan: 'edu',
  },
  {
    id: 'gpt-4.1',
    category: 'versatile',
    displayName: 'GPT-4.1',
    logoURL: OPENAI_LOGO,
    vendor: 'OpenAI',
    requiredPlan: undefined,
  },
  {
    id: 'claude-opus-4.7',
    category: 'powerful',
    displayName: 'Claude Opus 4.7',
    logoURL: ANTHROPIC_LOGO,
    vendor: 'Anthropic',
    requiredPlan: 'pro_plus',
  },
  {
    id: 'gpt-5.5',
    category: 'powerful',
    displayName: 'GPT-5.5',
    logoURL: OPENAI_LOGO,
    vendor: 'OpenAI',
    requiredPlan: 'pro_plus',
  },
  {
    id: 'gpt-5.4',
    category: 'powerful',
    displayName: 'GPT-5.4',
    logoURL: OPENAI_LOGO,
    vendor: 'OpenAI',
    requiredPlan: 'pro',
  },
] as const satisfies readonly RecommendedModelEntry[]

export const RECOMMENDED_MODEL_IDS = new Set<string>(RECOMMENDED_MODELS.map(m => m.id))
